import { types, successAction } from "@authzsvc/api-lib";

const identity = (state = null, action) => {
  switch (action.type) {
    case successAction(types.GET_IDENTITY):
      return action.payload.data;
    default:
      return state;
  }
};

export default identity;
